import styled from 'styled-components';

// import 'antd/lib/radio/style/index.css';

export const PageTitle = styled.div`
  margin: 0 auto 30px auto;
  width: auto;
  max-width: 1068px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  div:nth-child(2) {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 10px;
  }
  p {
    margin-left: 10px;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.21;
    letter-spacing: 0.01px;
    color: #999999;
    span {
      text-transform: capitalize;
      font-size: 14px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.21;
      letter-spacing: 0.01px;
      color: #74a50a;
    }
  }
  span {
    font-size: 18px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.28;
    letter-spacing: 0.01px;
    text-align: left;
    color: #619b30;
  }
  div.voltar {
    display: flex;
    align-items: center;
    flex-direction: row;
    margin-right: 20px;
    padding-top: 2px;
    button {
      display: flex;
      align-items: center;
      flex-direction: row;
      border: none;
      background: none;
      color: #619b30;
      font-weight: bold;
    }
  }
`;

export const BoxContent = styled.div`
  width: 1068px;
  min-height: 400px;
  padding: 20px 10px;
  margin: 0 auto;
  border: solid 0.8px #ebebeb;
  background-color: #f9f9f9;
  span.alertGreen {
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.17;
    letter-spacing: 0.01px;
    text-align: left;
    color: #74a50a;
    margin-top: -25px;
    display: block;
  }
`;

export const Container = styled.div`
  width: 100%;
  margin: 40px auto;
`;

export const Content = styled.div`
  width: 80%;
  margin: 0 auto;
  p {
    font-size: 13px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.15;
    letter-spacing: 0.01px;
    color: #282828;
  }
  h3 {
    margin-bottom: 50px;
    text-align: center;
    font-size: 24px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.21;
    letter-spacing: 0.01px;
    text-align: center;
    color: #282828;
    span {
      color: #74a50a;
    }
  }
`;

export const FormContainer = styled.div`
  input::placeholder {
    color: #999;
  }

  div.alerta-usuario-gestor-do-hospital {
    border-radius: 3px;
    border: solid 0.5px #a4c951;
    background-color: rgba(116, 165, 10, 0.16);
    display: flex;
    flex-direction: column;
    padding: 20px;

    span.titulo-alerta-usuario-gestor-do-hospital {
      width: 100%;
      font-family: Helvetica, sans-serif;
      font-size: 15px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 15px;
      letter-spacing: 0.01px;
      text-align: left;
      color: #588100;
      margin-bottom: 10px;
    }

    span.texto-alerta-usuario-gestor-do-hospital {
      width: 100%;
      font-family: Helvetica, sans-serif;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: 0.01px;
      text-align: left;
      color: #74a50a;
    }
  }

  div.left {
    width: 45%;
  }

  div.left-users {
    width: 32%;
  }

  div.right {
    width: 50%;
  }

  width: 100%;
  margin: 40px auto;
  input[type='text'],
  input[type='number'] {
    text-transform: uppercase;
    width: 100%;
    background: #ffffff;
    border: 0;
    border-radius: 4px;
    height: 35px;
    padding: 0 15px;
    color: #282828;
    margin: 0 0 0 0;
    box-shadow: inset 0px 1px 0px 0px #c7c7c794;
    border: solid 1px #c7c7c794;
    &::placeholder {
      color: #282828;
    }
    &:disabled {
      background: #f1f1f1;
    }
  }
  hr {
    /* border: solid 1px #b4b4b4; */
    height: 0.8px;
    background: #c7c7c794;
    opacity: 0.2;
    margin: 30px auto;
  }
`;

export const ButtonBox = styled.div`
  margin-top: 50px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  button {
    /* width: 90px; */
    height: 34px;
    padding: 0 50px;
    border-radius: 3.5px;
    background-color: #74a50a;
    border: none;
    color: #fff;
    display: flex;
    align-items: center;
  }
`;

export const BoxForm = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  span.redefinir-sua-senha-legenda {
    padding-top: 10px;
    font-family: Helvetica, sans-serif;
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 12px;
    letter-spacing: 0.22px;
    text-align: left;
    color: #999999;
  }

  span.repita-nova-senha-legenda {
    padding-top: 10px;
    font-family: Helvetica, sans-serif;
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 12px;
    letter-spacing: 0.22px;
    text-align: left;
    color: #999999;
  }

  .ultimo-login {
    margin-top: 20px;
  }

  .label-ultimo-login {
    font-family: Helvetica, sans-serif;
    font-size: 14px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 14px;
    letter-spacing: 0.01px;
    text-align: left;
    color: #282828;
    margin-right: 8px;
  }

  .dados-ultimo-login {
    font-family: Helvetica, sans-serif;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 14px;
    letter-spacing: normal;
    text-align: left;
    color: #74a50a;
  }

  /* auto complete */

  .certain-category-search-dropdown .ant-select-dropdown-menu-item-group-title {
    color: #666;
    font-weight: bold;
  }

  .certain-category-search-dropdown .ant-select-dropdown-menu-item-group {
    border-bottom: 1px solid #f6f6f6;
  }

  .certain-category-search-dropdown .ant-select-dropdown-menu-item {
    padding-left: 16px;
  }

  .certain-category-search-dropdown .ant-select-dropdown-menu-item.show-all {
    text-align: center;
    cursor: default;
  }

  .certain-category-search-dropdown .ant-select-dropdown-menu {
    max-height: 300px;
  }
`;

export const TitleSection = styled.h4`
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.21;
  /* letter-spacing: 0.01px; */
  text-align: left;
  color: #74a50a;
  margin-bottom: 20px;
`;

export const Row = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 20px;
  align-items: flex-end;
  /* border: 1px solid purple; */
`;
export const Col = styled.div`
  width: 100%;
  p {
    font-size: 11px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 2;
    letter-spacing: 0.01px;
    text-align: left;
    color: #282828;
  }
  span.errorField {
    color: #cc0000;
    font-size: 9px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;

    letter-spacing: 0px;
    margin-bottom: 5px;
  }
`;

export const Label = styled.span`
  font-size: 13px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.23;
  letter-spacing: 0.01px;
  text-align: left;
  color: #282828;
  margin-bottom: 8px;
  display: block;
`;

export const SwitchButton = styled.div`
  .ant-switch {
    min-width: 55px;
    height: 28px;
    line-height: 25px;
  }
  .ant-switch-checked {
    background-color: #74a50a;
  }

  .ant-switch-loading-icon,
  .ant-switch::after {
    width: 24px;
    height: 24px;
  }
  &::selection {
    color: #fff;
    background: #74a50a;
  }
`;

export const BoxNivelAcesso = styled.div`
  /* width: 343.8px; */
  min-height: 164px;
  padding: 20px;
  border-radius: 3px;
  border: solid 0.5px;
  border-color: ${props =>
    props.accessLevelActive ? '#a4c951' : 'transparent'};
  background-color: ${props =>
    props.accessLevelActive ? 'rgba(116, 165, 10, 0.16)' : ''};
  p {
    font-size: 13px;
    line-height: 15px;
    letter-spacing: 0.01px;
    text-align: left;
    color: ${props => (props.accessLevelActive ? '#74a50a' : '#999999')};
    margin-top: 7px;
  }

  .ant-radio-wrapper {
    color: #588100;
    font-size: 13px;
    font-weight: bold;
    font-variant: tabular-nums;
    line-height: 1.5;
    list-style: none;
    font-feature-settings: 'tnum', 'tnum';
    white-space: nowrap;
    cursor: pointer;
    span {
      color: ${props => (props.accessLevelActive ? '' : '#282828')};
      font-size: 13px;
      font-weight: bold;
      line-height: 24px;
      float: left;
      display: inline-block;
      letter-spacing: 0px;
    }
  }

  .ant-radio-checked .ant-radio-inner {
    border-color: #638e03;
    &:hover {
      border-color: #638e03;
    }
    &:focus {
      border-color: #638e03;
    }
  }

  .ant-radio-group-solid
    .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):hover {
    color: #fff;
    background: #73a700;
    border-color: #73a700;
  }
  .ant-radio-group-solid
    .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):active {
    color: #fff;
    background: #73a700;
    border-color: #73a700;
  }

  .ant-radio-inner::after {
    position: absolute;
    top: 4px;
    left: 4px;
    display: table;
    width: 12px;
    height: 12px;
    background-color: #638e03;
    border-top: 0;
    border-left: 0;
    border-radius: 8px;
    -webkit-transform: scale(0);
    -ms-transform: scale(0);
    transform: scale(0);
    opacity: 0;
    -webkit-transition: all 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);
    transition: all 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);
    content: ' ';
  }
  .ant-radio-inner {
    position: relative;
    top: 0;
    left: 0;
    display: block;
    width: 22px;
    height: 22px;
    background-color: #fff;
    border-color: #d9d9d9;
    border-style: solid;
    border-width: 1px;
    border-radius: 100px;
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
  }

  /*  */

  .ant-radio-checked::after {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 1px solid #73a700;
    border-radius: 50%;
    visibility: hidden;
    -webkit-animation: antRadioEffect 0.36s ease-in-out;
    animation: antRadioEffect 0.36s ease-in-out;
    animation-fill-mode: none;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
    content: '';
  }
`;

export const BoxAsyncSelect = styled.div`
  text-transform: uppercase;

  input[type='text'] {
    box-shadow: inset 0px 1px 0px 0px #fff;
  }
  > div {
    > div:first-child {
      height: 34px;
      &:hover {
        height: 34px;
      }

      > div {
        height: 34px;
        &:hover {
          min-height: 34px;
        }
      }
    }
  }
`;

export const BoxBloqueado = styled.div`
  height: 98px;
  padding: 15px;
  border-radius: 3px;
  border: solid 0.5px #cc0000;
  background-color: rgba(204, 0, 0, 0.15);

  display: flex;
  flex-direction: row;
  justify-content: space-evenly;

  span {
    font-size: 13px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.23;
    letter-spacing: 0.01px;
    text-align: left;
    color: #cc0000;
    display: block;
    margin-bottom: 5px;
  }

  p {
    font-size: 13px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.15;
    letter-spacing: 0.01px;
    text-align: left;
    color: #cc0000;
  }

  div + div {
    border-left: solid 1px #cc0000;
    padding-left: 23px;
  }

  div.causaBloqueio {
    width: 300px;
    height: 70px;

    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;

    svg {
      color: #cc0000;
      margin-right: 20px;
    }
  }
  div.tempoBloqueio {
    width: 210px;
    height: 70px;
    align-items: flex-start;
    justify-content: center;
    display: flex;
    flex-direction: column;
  }
  div.acaoBloqueio {
    width: 150px;
    height: 70px;
    align-items: flex-start;
    justify-content: center;
    display: flex;
    flex-direction: column;
    .ant-switch {
      min-width: 55px;
      height: 28px;
      line-height: 25px;
    }
    .ant-switch-checked {
      background-color: #cc0000;
    }

    .ant-switch-loading-icon,
    .ant-switch::after {
      width: 24px;
      height: 24px;
    }
    &::selection {
      color: #fff;
      background: #cc0000;
    }
  }
`;
